
import React from 'react';
import { Users, ShieldCheck, Heart, Globe } from 'lucide-react';
import { Logo } from '../components/Logo';

export const About: React.FC = () => {
  return (
    <div className="bg-white min-h-screen">
      {/* Header Section */}
      <div className="bg-brandGray py-24 px-4 border-b border-gray-200">
        <div className="max-w-4xl mx-auto text-center">
          <div className="bg-white inline-block p-6 rounded-3xl shadow-xl mb-12 transform hover:scale-[1.03] transition-all duration-500 border border-gray-100">
            <Logo size="xl" variant="dark" showDecorations={true} />
          </div>
          <h1 className="font-heading text-5xl md:text-6xl font-bold text-brandDark mb-8 uppercase tracking-tight">
            Quality You Can <span className="text-primary">Trust</span>
          </h1>
          <p className="text-xl text-gray-500 leading-relaxed font-light max-w-2xl mx-auto">
            Since 2010, Dakar Auto Sales has been Chicago's premier destination for premium pre-owned vehicles. Our brand represents a commitment to mechanical excellence and transparent service.
          </p>
        </div>
      </div>

      {/* Values Grid */}
      <div className="max-w-7xl mx-auto py-24 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16">
          <div className="text-center group">
            <div className="bg-white w-20 h-20 rounded-3xl flex items-center justify-center mx-auto mb-8 border-b-4 border-primary shadow-lg group-hover:translate-y-[-8px] transition-all">
              <ShieldCheck size={36} className="text-primary" />
            </div>
            <h3 className="font-heading text-2xl font-bold text-brandDark mb-4 uppercase">Unmatched Integrity</h3>
            <p className="text-gray-500 leading-relaxed text-sm">
              Transparency isn't just a word; it's our core principle. Full history reports and upfront pricing on every single vehicle in our collection.
            </p>
          </div>
          <div className="text-center group">
            <div className="bg-white w-20 h-20 rounded-3xl flex items-center justify-center mx-auto mb-8 border-b-4 border-accent shadow-lg group-hover:translate-y-[-8px] transition-all">
              <Users size={36} className="text-brandDark" />
            </div>
            <h3 className="font-heading text-2xl font-bold text-brandDark mb-4 uppercase">Customer Dedicated</h3>
            <p className="text-gray-500 leading-relaxed text-sm">
              Our specialists prioritize your lifestyle needs over sales quotas, ensuring you drive away in the perfect car for you.
            </p>
          </div>
          <div className="text-center group">
            <div className="bg-white w-20 h-20 rounded-3xl flex items-center justify-center mx-auto mb-8 border-b-4 border-danger shadow-lg group-hover:translate-y-[-8px] transition-all">
              <Globe size={36} className="text-danger" />
            </div>
            <h3 className="font-heading text-2xl font-bold text-brandDark mb-4 uppercase">Global Reach</h3>
            <p className="text-gray-500 leading-relaxed text-sm">
              From our Chicago hub to our branch in Dakar, Senegal, we connect global standards with local expertise.
            </p>
          </div>
        </div>
      </div>

      {/* Legacy Section */}
      <div className="bg-brandDark py-24 px-4">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-16">
          <div className="md:w-1/2 relative">
            <img 
              src="https://images.unsplash.com/photo-1560179707-f14e90ef3623?auto=format&fit=crop&q=80&w=800" 
              alt="Our Showroom" 
              className="rounded-lg shadow-2xl z-10 relative border border-gray-800"
            />
            <div className="absolute -bottom-6 -left-6 w-full h-full border-4 border-primary opacity-30"></div>
          </div>
          <div className="md:w-1/2">
            <h2 className="font-heading text-4xl font-bold text-white mb-8 uppercase">A Bridge Across <span className="text-primary">Continents</span></h2>
            <div className="space-y-6 text-gray-400 font-light leading-relaxed">
              <p>
                Dakar Auto Sales started with a simple vision: to eliminate the stress of buying a used vehicle. Our founder, Marcus Dakar, believed that every customer deserves a "new car" experience, even when buying pre-owned.
              </p>
              <p>
                The name "Dakar" is more than just a brand; it's our heritage. We are proud to operate our main hub in Chicago while maintaining a dedicated branch in <strong>Dakar, Senegal (334 Rue MZ 26)</strong>.
              </p>
              <p>
                This international connection allows us to understand the diverse needs of our clients and offer unique expertise in vehicle export and global automotive standards.
              </p>
              <p>
                Today, our showroom houses a curated collection that represents the best value in the Midwest and beyond. Experience the Dakar difference for yourself.
              </p>
            </div>
            <div className="mt-10">
              <div className="flex gap-4">
                <div className="h-1.5 w-12 bg-primary"></div>
                <div className="h-1.5 w-12 bg-accent"></div>
                <div className="h-1.5 w-12 bg-danger"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
